/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type MachinePart,
    MachinePartFromJSON,
    MachinePartToJSON,
} from '../models/MachinePart';

export interface CreateMachinePartRequest {
    /**
     * 
     */
    machinePart: MachinePart;
}

export interface CreateMachinePartAltRequest {
    /**
     * 
     */
    machinePart: MachinePart;
}

export interface DeleteMachinePartRequest {
    /**
     * 
     */
    id: string;
}

export interface GetMachinePartRequest {
    /**
     * 
     */
    id: string;
}

export interface UpdateMachinePartRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    machinePart: MachinePart;
}

/**
 * 
 */
export class MachinePartControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for createMachinePart without sending the request
     */
    async createMachinePartRequestOpts(requestParameters: CreateMachinePartRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['machinePart'] == null) {
            throw new runtime.RequiredError(
                'machinePart',
                'Required parameter "machinePart" was null or undefined when calling createMachinePart().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/machine-parts`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MachinePartToJSON(requestParameters['machinePart']),
        };
    }

    /**
     */
    async createMachinePartRaw(requestParameters: CreateMachinePartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachinePart>> {
        const requestOptions = await this.createMachinePartRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachinePartFromJSON(jsonValue));
    }

    /**
     */
    async createMachinePart(requestParameters: CreateMachinePartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachinePart> {
        const response = await this.createMachinePartRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createMachinePartAlt without sending the request
     */
    async createMachinePartAltRequestOpts(requestParameters: CreateMachinePartAltRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['machinePart'] == null) {
            throw new runtime.RequiredError(
                'machinePart',
                'Required parameter "machinePart" was null or undefined when calling createMachinePartAlt().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/machinepart`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MachinePartToJSON(requestParameters['machinePart']),
        };
    }

    /**
     */
    async createMachinePartAltRaw(requestParameters: CreateMachinePartAltRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachinePart>> {
        const requestOptions = await this.createMachinePartAltRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachinePartFromJSON(jsonValue));
    }

    /**
     */
    async createMachinePartAlt(requestParameters: CreateMachinePartAltRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachinePart> {
        const response = await this.createMachinePartAltRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteMachinePart without sending the request
     */
    async deleteMachinePartRequestOpts(requestParameters: DeleteMachinePartRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteMachinePart().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/machine-parts/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteMachinePartRaw(requestParameters: DeleteMachinePartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteMachinePartRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteMachinePart(requestParameters: DeleteMachinePartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMachinePartRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getAllMachineParts without sending the request
     */
    async getAllMachinePartsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/machine-parts`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAllMachinePartsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MachinePart>>> {
        const requestOptions = await this.getAllMachinePartsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MachinePartFromJSON));
    }

    /**
     */
    async getAllMachineParts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MachinePart>> {
        const response = await this.getAllMachinePartsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMachinePart without sending the request
     */
    async getMachinePartRequestOpts(requestParameters: GetMachinePartRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMachinePart().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/machine-parts/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getMachinePartRaw(requestParameters: GetMachinePartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachinePart>> {
        const requestOptions = await this.getMachinePartRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachinePartFromJSON(jsonValue));
    }

    /**
     */
    async getMachinePart(requestParameters: GetMachinePartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachinePart> {
        const response = await this.getMachinePartRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateMachinePart without sending the request
     */
    async updateMachinePartRequestOpts(requestParameters: UpdateMachinePartRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateMachinePart().'
            );
        }

        if (requestParameters['machinePart'] == null) {
            throw new runtime.RequiredError(
                'machinePart',
                'Required parameter "machinePart" was null or undefined when calling updateMachinePart().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/machine-parts/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MachinePartToJSON(requestParameters['machinePart']),
        };
    }

    /**
     */
    async updateMachinePartRaw(requestParameters: UpdateMachinePartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachinePart>> {
        const requestOptions = await this.updateMachinePartRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachinePartFromJSON(jsonValue));
    }

    /**
     */
    async updateMachinePart(requestParameters: UpdateMachinePartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachinePart> {
        const response = await this.updateMachinePartRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
